;(function () {
  'use strict'
  angular
    .module('contrast.application.assess')
    .controller('AssessPolicyModalCtrl', AssessPolicyModalCtrl)

  function AssessPolicyModalCtrl(
    $scope,
    $uibModalInstance,
    RulesService,
    ErrorService,
    appId,
    rules
  ) {
    'ngInject'

    angular.extend($scope, {
      model: {
        dev_enabled: false,
        qa_enabled: false,
        prod_enabled: false
      }
    })

    angular.extend($scope, {
      update: update,
      cancel: cancel
    })

    function update() {
      RulesService.bulkUpdateStatusByApplication(
        appId,
        _.map(rules, 'rule_name'),
        $scope.model.dev_enabled,
        $scope.model.qa_enabled,
        $scope.model.prod_enabled
      )
        .then(function () {
          $uibModalInstance.close()
        })
        .catch(ErrorService.processError)
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
